import store from '@/vuex/store'
import Socket from '@/socket'

const joinRoomPresentation = (uniqueAccesscode) => {
  const {
    id, avatar, firstName, lastName, email, accountRole,
  } = store.state.currentUser

  Socket.getSocket().emit('join-presenter', {
    room: `${uniqueAccesscode}-presenter`,
    presenter: {
      id,
      avatar,
      name: lastName ? `${firstName} ${lastName}` : firstName,
      socketId: Socket.getSocketId(),
      email,
      accountRole,
    },
  })
}

const leaveRoomPresentation = (uniqueAccessCode) => {
  Socket.getSocket().emit('leave', `${uniqueAccessCode}-presenter`)
}

const leaveRoomSlide = (uniqueAccessCode, slideId) => {
  Socket.getSocket().emit('leave', `${uniqueAccessCode}-${slideId}-presenter`)
}

const updateOldParticipants = (uniqueAccessCode, presentationId) => {
  Socket.getSocket().emit('update-old-participant', { uniqueAccessCode, presentationId })
}

const joinRoomSlide = (uniqueAccessCode, slideId) => {
  const {
    id, avatar, firstName, lastName, email,
  } = store.state.currentUser
  Socket.getSocket().emit('join-presenter', {
    room: `${uniqueAccessCode}-${slideId}-presenter`,
    presenter: {
      id,
      avatar,
      name: lastName ? `${firstName} ${lastName}` : firstName,
      socketId: Socket.getSocketId(),
      email,
    },
  })
}

const backstageControl = ({
  uniqueAccessCode,
  isForAudience,
  type,
  data,
}) => {
  if (store.getters['remoteControlLink/canDisableBackstageControlEvents']) {
    return
  }
  Socket.getSocket().emit('backstage-control', {
    uniqueAccessCode,
    isForAudience,
    socketId: Socket.getSocketId(),
    type,
    data,
  })
}

export default {
  joinRoomPresentation,
  joinRoomSlide,
  leaveRoomPresentation,
  leaveRoomSlide,
  backstageControl,
  updateOldParticipants,
}
